import React, { useEffect, useState } from 'react'
import { useShow, IResourceComponentsProps, useGetIdentity, useOne, useNavigation, useMany, useTable } from '@pankod/refine-core'
import { IPaperTemplate, IProduct, IQuestion, ISection, ITestTrack, IWorkRequest } from 'interfaces'
import { EditProduct } from './edit'
import { useUserContext } from 'context/user'
import Permissions from 'permissions'

import {
  Icons,
  Button,
  PageHeader,
  Typography,
  Skeleton,
  Descriptions,
  Divider,
  EditButton,
  Image,
  useModalForm,
  Collapse,
  Col,
  Row,
  Table,
} from '@pankod/refine-antd'

import metaData from 'metadata/products'
const { Text } = Typography
const { Panel } = Collapse

type Permission = {
  granted?: boolean
}

export const ProductShow: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const { userRole } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})

  const { queryResult, setShowId } = useShow<IProduct>({
    metaData,
  })

  const { show, push } = useNavigation()

  const { data, isLoading } = queryResult
  const record = data?.data
  console.log(record,"Record")
  const { tableQueryResult: templatesData } = useTable<IPaperTemplate>({
    resource: 'paper_templates',
    initialSorter: [
      {
        field: 'name',
        order: 'desc',
      },
    ],
    metaData: { fields: ['name', 'description'] },
    permanentFilter: [
      { field: 'active', operator: 'eq', value: true },
      { field: 'product_id', operator: 'eq', value: record?.id },
    ],
    initialPageSize:1000,
    queryOptions: { enabled: !!record },
  })

  const testTrackResult = useMany<ITestTrack>({
    resource: 'test_tracks',
    ids: record?.test_track_ids ?? [],
    metaData: {
      fields: ['id', 'name'],
    },
  })

  const paperTemplateResult = useOne<IProduct>({
    resource: 'products',
    id: record?.id ?? '',
    metaData: { fields: ['type',{paper_templates: ['id', 'name', 'description'] }] },
  })
  const paperTemplateArr = paperTemplateResult?.data?.data?.paper_templates

  const { setFilters: setSectionFilters, tableQueryResult: sectionResult } = useTable<ISection>({
    resource: 'sections',
    metaData: {
      fields: ['name', 'id'],
    },
    initialPageSize:1000
  })

  const hideButton = (record: IProduct | undefined): boolean => {
    let isTemplateActive = false
    console.log('eachProduct', record?.name, record?.test_event, record?.paper_templates)

    if (record?.test_event !== undefined && record?.paper_templates !== undefined) {
      const shouldHide = record.test_event.length > 0 || record.paper_templates.length > 0
      let templateCount = record?.paper_templates?.filter(template => template?.active === true)
      if (templateCount.length > 0) isTemplateActive = true

      return shouldHide && isTemplateActive
    }
    return false
  }

  useEffect(() => {
    setSectionFilters([
      {
        field: 'id',
        operator: 'in',
        value: record?.section_ids,
      },
    ])
  }, [record])

  useEffect(() => {
    setReadPermission(Permissions.can(userRole).readAny('products'))
    setCreatePermission(Permissions.can(userRole).createAny('products'))
    setEditPermission(Permissions.can(userRole).updateAny('products'))
    setDeletePermission(Permissions.can(userRole).deleteAny('products'))
  }, [userRole])

  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
    console.log(readPermission, 'readpermission')
  }, [readPermission])

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    resource: 'products',
    action: 'edit',
    metaData,
    redirect: false,
  })

  return (
    <PageHeader
      className="site-page-header-responsive"
      ghost={false}
      title={`#${record?.product_id ?? ''} - ${record?.name ?? ''}`}
      extra={[
        // (role === 'admin' || role === 'qbincharge' || role === 'subjectincharge') && <QuestionLogs questionId={record?.id} />,
        <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
          Back
        </Button>,

        <EditButton
          key="edit"
          hidden={hideButton(record)}
          // disabled={record?.status === 'Published' || record?.status === 'Retired'}
          icon={<Icons.EditOutlined />}
          type="primary"
          onClick={() => {
            editShow(record?.id)
          }}
        >
          Edit
        </EditButton>,
      ]}
    >
      {/* <Descriptions size="small" column={1}>
        <Descriptions.Item label="">
          <Tag
            color="geekblue"
          >
            status
          </Tag>
        </Descriptions.Item>
      </Descriptions> */}
      <Descriptions size="small" column={3}>
        <Descriptions.Item label="Product Name">{record?.name}</Descriptions.Item>
        <Descriptions.Item label="Description">
          {' '}
          <Text
            style={{
              width: 200,
              textAlign: 'left',
            }}
            ellipsis={{ tooltip: record?.description }}
          >
            {record?.description}
          </Text>
          {/* {record?.description} */}
        </Descriptions.Item>
        <Descriptions.Item label="Created By">{record?.userByCreatedBy?.displayName}</Descriptions.Item>
      </Descriptions>
      <Text>Test Tracks : </Text>
      {/* <Descriptions size="small">
        <Descriptions.Item label="Test tracks"> */}
      {testTrackResult?.data?.data?.map(item => (
        <Text keyboard>{item.name}</Text>
      ))}
      {/* </Descriptions.Item>
      </Descriptions> */}
      <Divider style={{ margin: '12px 0' }} />
      <Row>
        <Col xs={24}>
          <b>Product Paper Format:</b>
          <div style={{ marginTop: 5 }}>
            <Table
              style={{ display: 'inline-block', minWidth: '300px' }}
              // showHeader={false}
              size="small"
              bordered
              dataSource={record?.sections}
              // pagination={false}
              columns={[
                {
                  title: 'Id',
                  dataIndex: 'id',
                  render: (item, record, index) => <>{index + 1}</>,
                },
                {
                  title: 'Section Name',
                  dataIndex: 'name',
                  render: (_, record: any) => {
                    const section = sectionResult?.data?.data.filter(section => section.id === record?.section_id)
                    const sectionName = section && section[0]?.name

                    return <>{`${sectionName}`}</>
                  },
                },
                {
                  title: 'No Of Questions',
                  dataIndex: 'no_of_questions',
                  // render: (item, record, index) => <>{}</>,
                },
                {
                  title: 'Total Marks',
                  dataIndex: 'marks',
                  // render: (item, record, index) => <>{}</>,
                },
              ]}
            />
          </div>
        </Col>
        <Divider style={{ margin: '12px 0' }} />

        <Col xs={24}>
          <b>Associated Paper Templates:</b>
          <div style={{ marginTop: 5 }}>
            <Table
              size="small"
              dataSource={templatesData?.data?.data}
              bordered
              // pagination={false}
              columns={[
                { title: 'Sl No.', render: (_, record, idx) => <>{idx + 1}</> },
                {
                  title: 'name',
                  dataIndex: ['id', 'name'],
                  render: (item, record, index) => {
                    return (
                      <Typography.Link onClick={() => show('paper_templates', paperTemplateArr?.[index]?.id ?? '')}>
                        {paperTemplateArr?.[index]?.name}
                      </Typography.Link>
                    )
                  },
                },
                { title: 'description', dataIndex: 'description' },
              ]}
            />
          </div>
        </Col>
      </Row>

      {!record && <Skeleton paragraph={{ rows: 1 }} />}
      <EditProduct modalProps={editModalProps} formProps={editFormProps} close={editClose} record={record} />
    </PageHeader>
  )
}
